import { ExperienceList } from "../models/experience-list";

export const EXPERIENCES_LISTS: ExperienceList[] = [

  // Tipos de desconexion
  { id: 'relax', name: 'Relax', description: "", filters: [{ type: "tags", value: "relax" }] },
  { id: 'diversion', name: 'Diversión', description: "", filters: [{ type: "tags", value: "diversión" }] },
  { id: 'aventura', name: 'Aventura', description: "", filters: [{ type: "tags", value: "aventura" }] },
  { id: 'tranquilidad', name: 'Tranquilidad', description: "", filters: [{ type: "tags", value: "tranquilidad" }] },

  // Tipos de experiencias
  { id: 'gratis', name: 'Gratis', description: "", filters: [{ type: "tags", value: "gratis" }] },
  { id: 'privada', name: 'Privada', description: "", filters: [{ type: "tags", value: "privada" }] },
  { id: 'colectiva', name: 'Colectiva', description: "", filters: [{ type: "tags", value: "colectiva" }] },
  { id: 'fecha-definida', name: 'Fecha definida', description: "", filters: [{ type: "tags", value: "fecha-definida" }] },
  { id: 'reserva-flexible', name: 'Reserva Flexible', description: "", filters: [{ type: "tags", value: "reserva-flexible" }] },

  // Experiencias Urbanas
  { id: 'urbano', name: 'Urbano', description: "", filters: [{ type: "tags", value: "urbano" }] },
  { id: 'arte-cultura', name: 'Arte/cultura', description: "", filters: [{ type: "tags", value: "arte-cultura" }] },
  { id: 'inmersion-cultural', name: 'Inmersión cultural', description: "", filters: [{ type: "tags", value: "inmersion-cultural" }] },
  { id: 'experiencia-barrial', name: 'Experiencia barrial', description: "", filters: [{ type: "tags", value: "experiencia-barrial" }] },


  //  Actividades al Aire Libre
  { id: 'senderismo', name: 'Senderismo', description: "", filters: [{ type: "tags", value: "senderismo" }] },
  { id: 'naturaleza', name: 'Naturaleza', description: "", filters: [{ type: "tags", value: "naturaleza" }] },
  { id: 'adrenalina', name: 'Adrenalina', description: "", filters: [{ type: "tags", value: "adrenalina" }] },
  { id: 'experiencia-relajante', name: 'Experiencia Relajante', description: "", filters: [{ type: "tags", value: "experiencia-relajante" }] },

  //   Características Específicas
  { id: 'paisajes-aereos', name: 'Paisajes Aéreos', description: "", filters: [{ type: "tags", value: "paisajes-aereos" }] },
  { id: 'vista-impresionante', name: 'Vista impresionante', description: "", filters: [{ type: "tags", value: "vista-impresionante" }] },
  { id: 'aventura-extrema', name: 'Aventura Extrema', description: "", filters: [{ type: "tags", value: "aventura-extrema" }] },
  { id: 'instagrameable', name: 'Instagrameable', description: "", filters: [{ type: "tags", value: "instagrameable" }] },
  { id: 'fogata', name: 'Fogata', description: "", filters: [{ type: "tags", value: "fogata" }] },
  { id: 'recorrido-corto', name: 'Recorrido corto', description: "", filters: [{ type: "tags", value: "recorrido-corto" }] },

];



